<template>
  <div>
    <el-dialog
      :title="this.renewParams.activeType === 2?'保号':'续费'"
      :visible.sync="visible"
      width="500px"
    >
      <div class="price_box">
        <div class="price_row">
          <span class="price_label">已选时长:</span>
          <el-select
            style="width:360px;margin:0"
            v-model="renewParams.years"
            placeholder="请选择"
            @change="changeRenew"
          >
            <el-option
              v-for="item in LOGINUSER.userCode === 'SP324' ? priceTime : selectTime"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="price_row" v-if="passwordFlag == 1">
          <span class="price_label">密码:</span>
          <el-input
            style="width:360px"
            size="small"
            v-model="renewParams.secondPassword"
            type="password"
          />
        </div>
        <p class="price_p" v-if="renewParams.type == 3">
          提示：多个SIM卡可用“|”，“空格”，“,”隔开或号段例：1xxxx39600000-10
          <span
            class="download"
            @click="handleDownload"
          >模板下载（模板导入限制2000张卡）</span>
        </p>
        <div class="price_row" v-if="renewParams.type == 3">
          <span class="price_label">SIM卡号段：</span>
          <span class="price_Num">
            <el-input
              style="width:280px"
              @blur="changeRenew(renewParams.years);"
              type="text"
              v-model="renewParams.sim"
              placeholder="多个SIM卡可用|隔开或号段例：1xxxx39600000-10"
            />
            <el-upload
              class="upload-demo"
              style="width:70px;float:right"
              action
              multiple
              :http-request="({ file }) => (renewParams.excelFile = file)"
              :show-file-list="false"
              :on-change="handlerExport"
            >
              <el-button type="primary" size="small">上传文件</el-button>
            </el-upload>
          </span>
        </div>

        <div class="price_row">
          <span class="price_label">备注：</span>
          <span class="price_Num">
            <el-input
              style="width:360px"
              type="text"
              v-model="renewParams.remark"
            />
          </span>
        </div>
        <!-- <p class="box_p">
        <el-checkbox 
          v-model="renewParams.checked"
        >
          此操作将续费“
          <span>
            {{renewParams.years}}
          </span>
          ”年，
          停卡费“<span>{{renewVosNum}}</span>”个,
          消耗虚拟币“
          <span>
            {{renewParams.data?renewParams.data.data.allCorn : 0}}
          </span>
          ”个
        </el-checkbox>
        <span 
          class="vos__span"
          @click="stopCardMessage"
          v-if="renewVos.length">停卡详情</span>
        </p>-->
        <div class="price_row">
          <span class="price_row_span">提示：续费操作不能回退与修改，请谨慎操作</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible=false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="onoff"
          size="small"
          @click="handleOrder()"
        >确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看sim卡号 start -->
    <el-dialog
      title="提示"
      :visible.sync="outSimShow"
      :close-on-click-modal="false"
      width="600px"
    >
      <div
        style="word-wrap:break-word;height:300px;overflow-y:auto;padding:0 10px;text-align:center"
        v-html="outSimShowSimSegment"
      ></div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="renewDialogShow"
      :close-on-click-modal="false"
      width="320px"
    >
      <div class="renewDialog">
        <div class="renewDialog__content" v-if="insuranceList.length">
          <span>需要交保号费卡信息({{ insuranceList.length }}张)：
            <el-button v-if="insuranceList.length > 1" @click="insuranceShow = !insuranceShow" size="mini">{{ insuranceShow ? '收起' : '展开'}}</el-button>
            <el-button @click="copyText(insuranceList.join(','))" size="mini">复制</el-button>
          </span>
          <div :class="`${insuranceShow ? '' : 'overflow'}`">
            <p v-for="(item,index) in insuranceList" :key="item" v-show="insuranceShow ? true : !index">
              {{ item }}
            </p>
          </div>
        </div>
        <div class="renewDialog__content" v-if="downList.length">
          <span>已注销卡信息({{ downList.length }}张)：
            <el-button v-if="downList.length > 1" @click="downShow = !downShow" size="mini">{{ downShow ? '收起' : '展开'}}</el-button>
            <el-button @click="copyText(downList.join(','))" size="mini">复制</el-button>
          </span>
          <div :class="`${downShow ? '' : 'overflow'}`">
            <p v-for="(item,index) in downList" :key="item" v-show="downShow ? true : !index">
              {{ item }}
            </p>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 查看sim卡号 end -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      renewDialogShow:false,
      insuranceShow:false,
      insuranceList: [],
      downShow:false,
      downList:[],
      outSimShow: false,
      outSimShowSimSegment: '',
      visible: false,
      renewVos: [],
      // renewVosNum: 0,
      renewParams: {
        years: 1,
        name: '',
        activeType: 0,//0：续费 1：叠加包 2保号
        years: 1,
        remark: '',
        type: 0,
        sim: '',
        data: null,
        checked: false,
        secondPassword: '',
        excelFile: null
      },
      priceTime: [
        {
          value: 1,
          label: "1年"
        },
        {
          value: 2,
          label: "2年"
        },
        {
          value: 3,
          label: "3年"
        }
      ],//续费时间
      protectTime: [
        {
          value: 1,
          label: "1月"
        },
      ],//保号时间
      onoff: false
    }
  },
  computed: {
    LOGINUSER() {
      return this.$store.state.LOGINUSER;
    },
    //获取支付密码状态
    passwordFlag() {
      return this.$store.state.passwordFlag;
    },
    selectTime() {
      if (this.renewParams.activeType === 0) { return this.priceTime }
      if (this.renewParams.activeType === 2) { return this.protectTime }
    }
  },
  mounted() {
    // this.stopCardMessage();
  },
  watch: {
    visible(newVal,oldVal){
      if(!newVal){
        console.log(12312312)
        this.renewParams = {
          years: 1,
          name: '',
          activeType: 0,//0：续费 1：叠加包 2保号
          years: 1,
          remark: '',
          type: 0,
          sim: '',
          data: null,
          checked: false,
          secondPassword: '',
          excelFile: null
        }
      }
    }

  },

  methods: {
    copyText (text) {
      let oInput = document.createElement('input');
      oInput.value = text;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand('Copy'); // 执行浏览器复制命令
      oInput.remove();
      this.$message.success('复制成功');
    },
    //下载模板
    handleDownload() {
      window.open('./renew.xlsx')
    },
    //导入SIM卡
    async handlerExport(row) {
      let formData = new FormData();
      formData.append('file', row.raw);
      const { data } = await this.$API.parserExcelToSegment(formData);
      if (data.code == 0) {
        this.renewParams.type = 3;
        this.renewParams.sim = data.data;
        this.changeRenew(this.renewParams.years);
      }
      this.$message({
        type: data.code == 0 ? 'success' : 'warning',
        message: data.code == 0 ? '上传成功' : data.msg
      })
    },

    //停卡费提示
    stopCardMessage() {
      const h = this.$createElement;
      let html = [];
      this.renewVos.map(item => {
        html.push(h('p', null, `卡号：${item.simCard}；停卡费：${item.expireMonth}个虚拟币`))
      })
      this.$msgbox({
        title: 'SIM卡',
        message: h('div', { style: 'width:400px;height:300px;overflow:auto;' }, html),
        showCancelButton: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          done();
        }
      }).catch(error => {
        console.log(error);
      })
    },

    //续费
    handleOrder() {
      if (this.outSimShowSimSegment != '') {
        this.outSimShow = true;
        return false;
      }
      //  allIccid  没有的话 allIccid就是批量套餐升级

      if (this.renewParams.data.data.errorList.length) {
        this.outSimShow = true;
        this.outSimShowSimSegment = this.renewParams.activeType === 2 ? '此卡已交保号费、非北京卡、未过期或已注销：' + this.renewParams.data.data.errorList.toString() + this.renewParams.data.data.oldList.toString() : '该卡非北京卡，不支持该业务，请核实：' + this.renewParams.data.data.errorList.join(',');
      } else {
        this.onoff = true;
        let dateName = '年'
        if(this.$store.state.LOGINUSER.userCode === 'SP324' && this.renewParams.activeType === 2){
          dateName = '年'
        }else if(this.renewParams.activeTyp === 2){
          dateName = '月'
        }
        const str = `<p class="box_p">
            此操作将续费“
            <span style="color:#d61c1c">
              ${this.renewParams.years}
            </span>
            ”${dateName}，
            消耗虚拟币“
            <span style="color:#d61c1c">
              ${this.renewParams.data ? this.renewParams.data.data.allCorn : 0}
            </span>
            ”个
        </p>`;
        this.$alert(str, '提示', {
          dangerouslyUseHTMLString: true
        }).then(action => {
          const param = {
            corn: this.renewParams.data.data.allCorn,
            simSegment: this.renewParams.type == 3 ? this.renewParams.sim.replace(/([\r\n]|,|，)/g, '|') : this.renewParams.sim,
            years: this.renewParams.years,
            type: this.renewParams.type,
            secondPassword: this.renewParams.secondPassword,
            remark: this.renewParams.remark
          }
          const query = this.renewParams.activeType === 2 ? (this.$API.operationGuaranteeInfo(param)) : (this.$API.exameCornRenew(param))
          query.then(res => {
            try{
              // this.renewParams.checked = false;
              if (this.renewParams.activeType !== 2 && res.data.data){
                const { insuranceList , downList } = res.data.data;
                this.insuranceList = insuranceList;
                this.downList = downList || [];
                this.renewDialogShow = true;
                return;
              }
              if (res.data.data && res.data.data.length) {
                this.outSimShowSimSegment = res.data.msg + ':' + res.data.data.toString()
                this.outSimShow = true
              } else {
                this.$message({
                  type: res.data.code == 0 ? "success" : "warning",
                  message: res.data.msg
                })
              }
              this.onoff = false;
              res.data.code == 0 && (
                this.visible = false,
                this.$emit('searchSimList')
              );
            }catch(err){
              console.log(err)
            }
          }).catch(error => {
            // this.renewParams.checked = false;
            console.log(error)
            this.$message({
              type: 'warning',
              message: error.msg
            });
            this.onoff = false;
          })
        });
        this.onoff = false;
        this.$API.getUserCornInfo()
      }
    },
    //获取消耗币数
    async changeRenew(val) {
      // this.renewVosNum = 0;

      if (this.renewParams.sim) {
        let params = {
          simSegment: this.renewParams.type == 3 ? this.renewParams.sim.replace(/([\r\n\s]|,|，)/g, '|') : this.renewParams.sim,
          years: this.renewParams.activeType === 2 ? this.renewParams.years : val, //保号是 1 续费是val
          type: this.renewParams.type
        }
        const { data, code } = this.renewParams.activeType === 2 ? (await this.$API.confirmGuaranteeInfo(params)) : (await this.$API.renewCardByCorn(params));
        if(this.renewParams.activeType === 2){
          console.log(data)
          if(!data.data){
            this.$message({
              type: 'warning',
              message: data.msg
            });
            this.renewParams.data = []
            return;
          }
          if(!data.data.errorList.length && !data.data.oldList.length){
            this.visible = true;
            this.renewParams.data = data;
            this.renewVos = data.data.renewVos ? data.data.renewVos : [];
            this.outSimShowSimSegment = '';
          }else{
            this.visible = false;
            this.outSimShow = true;
            this.outSimShowSimSegment = data.msg + '：' + [ ...data.data.errorList , ...data.data.oldList ].join(',');
          }
          return ;
        }
        if (data.code == 0) {
          this.visible = true;
          this.renewParams.data = data;
          this.renewVos = data.data.renewVos ? data.data.renewVos : [];
          // this.renewVos.map(item => {
          //   this.renewVosNum += item.expireMonth;
          // })
          this.outSimShowSimSegment = '';
        } else if (data.code == '11007') {
          this.$message({
            type: 'warning',
            message: data.msg
          });
          this.outSimShowSimSegment = '';
        } else {
          this.outSimShow = true;
          this.outSimShowSimSegment = data.msg + '：' + data.data.join(',');
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.price_box {
  .renew_btn {
    width: 90px;
    height: 30px;
    background: #eb5b5b;
    color: #fff;
    text-align: center;
    line-height: 30px;
    margin: auto;
    border-radius: 6px;
    cursor: pointer;
  }
  .vos__span {
    display: inline-block;
    margin-left: 10px;
    cursor: pointer;
    color: #409eff !important;
  }
  .download {
    color: #409eff;
    cursor: pointer;
    text-align: right;
    margin: 10px 0;
    display: inline-block;
  }
  // margin:
  .box_p {
    margin: 10px 0 20px 0;
    line-height: 26px;
    span {
      color: #eb5b5b;
    }
  }
  .price_Num {
    font-size: 14px;
    font-family: PingFang-SC-Bold;
    // font-weight: bold;
    display: inline-block;
    // margin-left: 10px;
    color: #d61c1c;
  }
  .price_p {
    color: #999;
    margin: 20px 0;
    font-size: 12px;
  }
  .price_row {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    &_span {
      color: #d61c1c;
      font-size: 12px;
    }
    .price_code {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      // text-align: center;
      align-items: center;
      &:nth-child(2) {
        margin-left: 50px;
      }
      span {
        font-size: 12px;
        font-family: PingFang-SC-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
      img {
        width: 148px;
        height: 148px;
      }
    }
  }
  .price_label {
    display: inline-block;
    width: 100px;
    font-size: 14px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  & /deep/ .input__suffix {
    top: 5px;
  }
  & /deep/ .el-input__inner {
    height: 30px;
    line-height: 30px;
  }
}
.renewDialog{
  min-height: 200px;
  max-height: 400px;
  overflow-y: auto;
  &__content{
    display: flex;
    justify-content: flex-start;
    font-size: 14px;
    margin-bottom: 10px;
    flex-wrap: wrap;
    position: relative;
    >span{
      display: block;
      width: 100%;
      text-align: center;
      color: #666;
      padding: 4px 0;
      button{
        height: 24px;
        line-height: 24px;
        padding: 0 10px;
      }
    }
    >div{
      width: 100%;
      text-align: center;
      color: #000;
      line-height: 20px;
      >p{
        padding: 4px 0;
      }
    }
    .overflow{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>